import { observable } from 'mobx';

export type DomesticAirlineResponseArgs = {
  id: number;
  three_letter_code: string;
  two_letter_code: string | null;
  name: string;
  created_at: string;
  updated_at: string;
};

export type DomesticAirlineArgs = {
  id: number;
  threeLetterCode: string;
  twoLetterCode: string | null;
  name: string;
  createdAt: string;
  updatedAt: string;
};

export const convertDomesticAirlineResponseToArgs = (
  response: DomesticAirlineResponseArgs
): DomesticAirlineArgs => {
  return {
    id: response.id,
    threeLetterCode: response.three_letter_code,
    twoLetterCode: response.two_letter_code,
    name: response.name,
    createdAt: response.created_at,
    updatedAt: response.updated_at
  };
};

export default class DomesticAirline {
  @observable id: number;
  @observable threeLetterCode: string;
  @observable twoLetterCode: string | null;
  @observable name: string;
  @observable createdAt: string;
  @observable updatedAt: string;

  constructor(args: DomesticAirlineArgs) {
    this.id = args.id;
    this.threeLetterCode = args.threeLetterCode;
    this.twoLetterCode = args.twoLetterCode;
    this.name = args.name;
    this.createdAt = args.createdAt;
    this.updatedAt = args.updatedAt;
  }

  get submitParams() {
    return {
      three_letter_code: this.threeLetterCode,
      two_letter_code: this.twoLetterCode,
      name: this.name
    };
  }

  static createEmpty(): DomesticAirline {
    return new DomesticAirline({
      id: 0,
      threeLetterCode: '',
      twoLetterCode: null,
      name: '',
      createdAt: '',
      updatedAt: ''
    });
  }
}
